export class SaleOrderIdRequest {
    saleOrderId:number;
    plantId?:number;
    itemId?:number;
    poNumber?:string;
    stockOutType?:string;
    stockType?:string;
    productId?:number;
    packStyleId?:number;
    reportedCases?:number;
    packStyleIdArray ? :[]
    productIdArray ?: []
    soakingOutProduct?:string
    loosePouches?:number
    noOfPouches?:number
    stockInType?:string
    fromRefNo?:number
    toRefNo?:number
    lotType?:string

    constructor(saleOrderId: number, plantId?: number,itemId?:number,poNumber?:string,stockOutType?:string,stockType?:string,productId?:number,packStyleId?:number,reportedCases?:number,packStyleIdArray ? :[],productIdArray ?: [],soakingOutProduct?:string,loosePouches?:number,noOfPouches?:number,stockInType?:string,fromRefNo?:number,toRefNo?:number,lotType?:string) {
        this.saleOrderId = saleOrderId;
        this.plantId = plantId;
        this.itemId = itemId;
        this.poNumber = poNumber;
        this.stockOutType = stockOutType;
        this.stockType = stockType;
        this.productId = productId
        this.packStyleId = packStyleId
        this.reportedCases= reportedCases
        this.packStyleIdArray = packStyleIdArray
        this.productIdArray = productIdArray
        this.soakingOutProduct = soakingOutProduct
        this.loosePouches = loosePouches
        this.noOfPouches = noOfPouches
        this.stockInType = stockInType
        this.fromRefNo = fromRefNo
        this.toRefNo = toRefNo
        this.lotType = lotType
    }

}